import MuiTypography from '@mui/material/Typography';
import { Chip, Stack, Tooltip } from '@mui/material';
import { EmailRounded } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { green, red } from '@mui/material/colors';
import Text from '../../../components/detail/components/Text.component';
import dayjs from 'dayjs';
import { getColorConfig, getIcon } from '../../yachts/conf/Data.conf';

export const ListConf = {
  initialState: {
    pagination: {
      page: 1,
      pageSize: 25,
    },
    sort: {
      by: 'createdAt',
      direction: 'desc',
    },
  },
  rowsPerPageOptions: [25, 50, 100],
  columns: [
    {
      id: 'attributes.name',
      key: 'attributes.name',
      sort_key: 'id_users_permissions_user.name',
      sortable: true,
      label: 'Name',
      width: '120px',
    },
    {
      id: 'attributes.surname',
      key: 'attributes.surname',
      sort_key: 'id_users_permissions_user.surname',
      sortable: true,
      label: 'Surname',
      width: '120px',
    },
    {
      id: 'attributes',
      key: 'attributes',
      sort_key: 'crew_responsability',
      sortable: true,
      label: 'Role',
    },
    {
      id: 'attributes.id_yacht',
      key: 'attributes.id_yacht',
      sort_key: 'id_yacht.yacht_name',
      sortable: true,
      label: 'Yacht',
    },
    {
      id: 'attributes.email',
      key: 'attributes.email',
      sort_key: 'id_users_permissions_user.email',
      sortable: true,
      label: 'Email',
    },
    {
      id: 'attributes.phone_number',
      key: 'attributes.phone_number',
      sort_key: 'id_users_permissions_user.phone_number',
      sortable: true,
      label: 'Phone',
    },
    {
      id: 'attributes.is_delivery_manager_on_board',
      key: 'attributes.is_delivery_manager_on_board',
      sort_key: 'is_delivery_manager_on_board',
      sortable: false,
      label: 'Manager on Board',
      width: 100,
      display: { xs: 'none', md: 'table-cell' },
    },
    {
      id: 'attributes.id_yacht',
      key: 'consents',
      sort_key: 'consents',
      sortable: false,
      label: 'Terms & Conditions',
      width: 200,
      maxWidth: 200,
      display: { xs: 'none', md: 'table-cell' },
    },
  ],
  render: {
    formatHead: (key, value) => {
      switch (key) {
        default:
          return (
            <MuiTypography
              variant='body1'
              sx={{ fontWeight: 'bold', color: 'white' }}
            >
              {value.toUpperCase()}
            </MuiTypography>
          );
      }
    },
    formatValue: (key, value, onClick) => {
      switch (key) {
        case 'attributes.email':
          return (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <EmailRounded color='action' />
              <MuiTypography
                sx={{ fontWeight: 'bold', height: 1 }}
                variant='body1'
                onClick={onClick}
              >
                {value || '-'}
              </MuiTypography>
            </Stack>
          );

        case 'attributes':
          return (
            <MuiTypography
              sx={{ fontWeight: 'bold', height: 1 }}
              variant='body1'
              onClick={onClick}
            >
              {value?.crew_responsability || '-'} <br />
              {value?.start_date || value?.end_date
                ? `(${value?.start_date ? dayjs(value?.start_date).format('DD/MM/YYYY') : ''} - ${value?.end_date ? dayjs(value?.end_date).format('DD/MM/YYYY') : ''})`
                : ''}
            </MuiTypography>
          );

        case 'attributes.id_yacht':
          return (
            <Stack
              direction={'row'}
              justifyContent={'space-between'}
              spacing={1}
            >
              <MuiTypography variant='body1'>
                {value?.yacht_name || '-'}
              </MuiTypography>
              <Chip label={`#${value?.id || '-'}`} size='small' />
            </Stack>
          );

        case 'attributes.is_delivery_manager_on_board':
          return (
            <Text
              label=''
              value={
                value ? (
                  <CheckCircleIcon sx={{ color: green[500] }} />
                ) : (
                  <CancelIcon sx={{ color: red[500] }} />
                )
              }
            />
          );

        case 'consents': {
          const marketingValue = value?.feedback;
          const newsletterValue = value?.commercial;

          const options = [
            {
              type: 'marketing',
              label: 'MRK',
              value: marketingValue,
              tooltip: 'MARKETING',
            },
            {
              type: 'newsletter',
              label: 'NLT',
              value: newsletterValue,
              tooltip: 'NEWSLETTER',
            },
          ];

          return (
            <Stack direction='row' spacing={2} onClick={onClick}>
              {options.map(({ type, label, value, tooltip }, index) => {
                const config = getColorConfig(value);

                return (
                  <Tooltip key={index} title={tooltip}>
                    <Chip
                      icon={getIcon(type, value)}
                      label={label}
                      sx={{
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                        padding: '2px 5px',
                        color: config.textColor,
                        borderRadius: '20px',
                        backgroundColor: 'transparent',
                      }}
                    />
                  </Tooltip>
                );
              })}
            </Stack>
          );
        }

        default:
          return (
            <MuiTypography variant='body1' onClick={onClick}>
              {value ? value : '-'}
            </MuiTypography>
          );
      }
    },
  },
};